export default __webpack_public_path__ + "static/tdp-3d50573afb98349049c4c5953be003de.png";